<template>
  <div class="line">
    <icon
      v-if="isIconOnRight"
      :icon-name="iconName"
      :color="color"
      variant="rounded"
      size="20px"
      fill
    />
    <div class="text">
      {{ text }}
    </div>
    <icon
      v-if="!isIconOnRight"
      :icon-name="iconName"
      :color="color"
      variant="rounded"
      size="20px"
      fill
    />
  </div>
</template>

<script lang="ts" setup>
import Icon from '@riseupil/base-ui/src/components/Icon.vue';
import Colors from '@riseupil/base-ui/src/scss/riseup-js-colors.module.scss';
import { computed } from 'vue';
import { IconPosition } from './IconLineTypes';

interface Props {
  iconName: string;
  text: string;
  color?: string;
  iconPosition?: IconPosition;
}

const props = withDefaults(
  defineProps<Props>(),
  {
    color: Colors.riseupBlack,
    iconPosition: IconPosition.right,
  },
);

const isIconOnRight = computed(() => props.iconPosition === IconPosition.right);
</script>

<style lang="scss" scoped>
@import "../../../../node_modules/base-ui-vue3/src/scss/riseup-colors";

.line {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;

  .text {
    font-family: SimplerPro, sans-serif;
    color: v-bind(color);
    font-size: 14px;
    // To give a centered feeling for text - to align with icons
    line-height: 22px;
    // Since line height is a bit larger than box height we
    // we want to hide the overflow
    overflow: hidden;
  }
}
</style>
